<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
      class="ma-0"
    >
      <v-alert
        width="100%"
        dense
        text
        v-if="alert"
        :type="alertType"
      >
        {{ alertText }}
      </v-alert>
    </v-row>
    <v-row
      align="center"
      justify="center"
      class="ma-0"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-card-title class="title">Uploads manuais</v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-container fluid>
              <v-row
                align="center"
              >
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                >
                  <v-text-field
                    label="Sub pasta"
                    v-model="subdirectory"
                    prepend-icon="mdi-folder"
                    hint="Sub pasta onde serão armazenados os uploads"
                    persistent-hint
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                >
                  <v-select
                    v-model="expiresIn"
                    :items="expireList"
                    label="Expira em"
                    prepend-icon="mdi-timer"
                    single-line
                    hint="Tempo até a expiração do link"
                    persistent-hint
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0 my-2">
                <v-spacer/>
                <v-btn
                  color="accent"
                  outlined
                  @click="onGenerateClick"
                  :disabled="!subdirectory"
                >
                  Gerar link
                </v-btn>
              </v-row>

              <div v-if="urlGenerated">
                <v-divider class="mt-5 mb-5"/>
                <v-row align="center">
                  <v-col cols="12">
                    <v-text-field
                      id="url-field"
                      label="Link para upload manual"
                      v-model="temporaryUrl"
                      prepend-icon="mdi-link"
                      hint="Compartilhe este link com operadores, 
                        parceiros ou clientes para que possam fazer 
                        uploads manuais na plataforma"
                      persistent-hint
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row class="ma-0 my-2">
                  <v-spacer/>
                  <v-btn
                    color="accent"
                    outlined
                    @click="copyToClipboard"
                  >
                    Copiar link
                  </v-btn>
                </v-row>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
    <v-snackbar
      v-model="showSnackbar"
      :timeout="snackbarTimeout"
    >
      Link copiado com sucesso!
    </v-snackbar>
  </v-container>
</template>

<script>
import {createUploadLink} from "@/api/api-project";
import {FRONTEND_URL} from "./../../globals"

export default {
  name: "ManualUploadForm",
  data() {
    return {
      alert: false,
      alertText: '',
      alertType: 'success',
      isFormValid: false,
      subdirectory: "",
      expiresIn: "3hours",
      expireList: [
        {value: "3hours", text: "3 horas"},
        {value: "1day", text: "1 dia"},
        {value: "7days", text: "7 dias"}
      ],
      temporaryUrl: "",
      urlGenerated: false,
      showSnackbar: false,
      snackbarTimeout: 2000,
      rules: {
        required: value => !!value || 'Obrigatório'
      }
    }
  },
  methods: {
    onGenerateClick() {
      const userId = this.$store.state.user.userData.idUserAccount
      createUploadLink(this.$apiAuth.getAuthToken(), this.subdirectory, this.expiresIn, userId, FRONTEND_URL)
        .then((res) => {
          if (res.data.data.status == 200) {
            this.temporaryUrl = res.data.data.url
            this.urlGenerated = true
            this.alertText = 'URL gerada com sucesso!'
            this.alertType = 'success'
          }
          if (res.data.data.status == 422) {
            this.temporaryUrl = ''
            this.urlGenerated = false
            this.alertText = res.data.message
            this.alertType = 'error'
          }
          this.alert = true
        })
    },
    copyToClipboard() {
      const fieldToCopy = document.querySelector('#url-field')
      fieldToCopy.select()
      fieldToCopy.setSelectionRange(0, 99999)
      document.execCommand("copy")
      this.showSnackbar = true
    }
  }
}
</script>

<style scoped>

</style>